import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Grid,
  Stack,
  Typography
} from "@mui/material"
import { green, orange, red } from "@mui/material/colors"
import { useState } from "react"

function DashboardPage() {
  const [count, setCount] = useState(0)

  return (
    <Stack spacing={2} sx={{ textAlign: "center" }}>
      <Typography
        variant="h1"
        color="primary"
        fontWeight="bold"
        sx={{ fontSize: "2rem" }}
      >
        Qpien Dashboard
      </Typography>
      <Typography
        variant="subtitle2"
        gutterBottom
        sx={{ color: "black", fontSize: "0.8rem" }}
      >
        Manage your Qpien platforms, templates and errors from here
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Card>
            <CardHeader
              avatar={
                <Avatar sx={{ bgcolor: green[500] }}>
                  <Typography variant="h6">P</Typography>
                </Avatar>
              }
              title="Platform"
              subheader="Total platform count"
            />
            <CardContent>
              <Typography variant="h5" gutterBottom>
                {count}
              </Typography>
              <Button
                onClick={() => setCount(count + 1)}
                variant="contained"
                color="success"
              >
                Increment
              </Button>
              <Box mt={2}>
                <Chip label="Total Platforms" color="success" />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card>
            <CardHeader
              avatar={
                <Avatar sx={{ bgcolor: orange[500] }}>
                  <Typography variant="h6">T</Typography>
                </Avatar>
              }
              title="Templates"
              subheader="Total template count"
            />
            <CardContent>
              <Typography variant="h5" gutterBottom>
                100
              </Typography>
              <Button variant="contained" color="warning">
                Templates
              </Button>
              <Box mt={2}>
                <Chip label="Total Templates" color="warning" />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card>
            <CardHeader
              avatar={
                <Avatar sx={{ bgcolor: red[500] }}>
                  <Typography variant="h6">E</Typography>
                </Avatar>
              }
              title="Errors"
              subheader="Total error count"
            />
            <CardContent>
              <Typography variant="h5" gutterBottom>
                0
              </Typography>
              <Button variant="contained" color="error">
                Errors
              </Button>
              <Box mt={2}>
                <Chip label="Total Errors" color="error" />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Box mt={2} display="flex" justifyContent="center">
        <Typography
          variant="subtitle2"
          gutterBottom
          sx={{ color: "blue", fontSize: "0.8rem" }}
        >
          Last 7 days statistics:
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Card>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                1000
              </Typography>
              <Typography
                variant="subtitle2"
                gutterBottom
                sx={{ color: "black", fontSize: "0.8rem" }}
              >
                Platforms
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                100
              </Typography>
              <Typography
                variant="subtitle2"
                gutterBottom
                sx={{ color: "black", fontSize: "0.8rem" }}
              >
                Templates
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                0
              </Typography>
              <Typography
                variant="subtitle2"
                gutterBottom
                sx={{ color: "black", fontSize: "0.8rem" }}
              >
                Errors
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Box mt={2} display="flex" justifyContent="center">
        <Typography
          variant="subtitle2"
          gutterBottom
          sx={{ color: "blue", fontSize: "0.8rem" }}
        >
          Last 30 days statistics:
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Card>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                5000
              </Typography>
              <Typography
                variant="subtitle2"
                gutterBottom
                sx={{ color: "black", fontSize: "0.8rem" }}
              >
                Platforms
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                500
              </Typography>
              <Typography
                variant="subtitle2"
                gutterBottom
                sx={{ color: "black", fontSize: "0.8rem" }}
              >
                Templates
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                10
              </Typography>
              <Typography
                variant="subtitle2"
                gutterBottom
                sx={{ color: "black", fontSize: "0.8rem" }}
              >
                Errors
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Stack>
  )
}

export default DashboardPage
